import { render, staticRenderFns } from "./AlvoradaRecemNascido.vue?vue&type=template&id=22300c2b&scoped=true"
import script from "./AlvoradaRecemNascido.vue?vue&type=script&lang=ts"
export * from "./AlvoradaRecemNascido.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaRecemNascido.vue?vue&type=style&index=0&id=22300c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22300c2b",
  null
  
)

export default component.exports